import { render } from "./ManageStudentsInClassRoom.vue?vue&type=template&id=7f9d60ff&scoped=true"
import script from "./ManageStudentsInClassRoom.vue?vue&type=script&lang=js"
export * from "./ManageStudentsInClassRoom.vue?vue&type=script&lang=js"

import "./ManageStudentsInClassRoom.vue?vue&type=style&index=0&id=7f9d60ff&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9d60ff"]])

export default __exports__